import { Button, Text, 
         Modal, ModalOverlay, ModalBody, ModalFooter, ModalCloseButton, ModalContent, ModalHeader, Spinner,
         Alert, AlertIcon, AlertTitle, AlertDescription } from '@chakra-ui/react'
import { useState, useEffect } from 'react'

import { Link } from 'react-router-dom'

function StatusOverlay({type, text, hideRefresh = false}) {

    const [displayAlert, setDisplayAlert] = useState(true)

    function hideAlert() {
        setDisplayAlert(false)
    }

    useEffect(() => {
        setTimeout(function() {
            hideAlert()
        }, 5000)
    },[])

    if (type === "modal") {
        return (
            <>
            <Modal isOpen>
            <ModalOverlay />
            <ModalContent>
            <ModalHeader>Error</ModalHeader>
            <ModalBody>
                <Text>{text}</Text>
            </ModalBody>

            <ModalFooter>
                { !hideRefresh && (
                    <Button colorScheme='blue' mr={3} onClick={(() => window.location.reload(false))}>
                        Refresh
                    </Button>
                )}
                <Link to="/"><Button variant='outline'>Home</Button></Link>
            </ModalFooter>
            </ModalContent>
            </Modal>
            </>
        )
    } else if (type === "top-alert-success") {

        if (!displayAlert)
            return (<></>)
        
        window.scrollTo(0, 0)
        return (
            <>
            <Alert status='success'>
                <AlertIcon />
                {text}.
            </Alert>
            </>
        )
    } if (type === "top-alert-error") {
        if (!displayAlert) 
            return (<></>)

        return (
            <>
            <Alert status='error'>
                <AlertIcon />
                {text}
            </Alert>
            </>
        )
    } else {
        return (<>Error in loading error overlay type selection</>)
    }
  
}

export default StatusOverlay